import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_LICENSE: createAsyncMutation('GET_LICENSE'),
    GET_LICENSE_KEYS_CUSTOMER: createAsyncMutation('GET_LICENSE_KEYS_CUSTOMER'),
    GET_LICENSE_KEYS_ORDER: createAsyncMutation('GET_LICENSE_KEYS_ORDER'),
    GET_LICENSES_CUSTOMER: createAsyncMutation('GET_LICENSES_CUSTOMER'),
    GET_LICENSES_FOR_RENEW_UPGRADE: createAsyncMutation('GET_LICENSES_FOR_RENEW_UPGRADE'),
    GET_LICENSES_ORDER: createAsyncMutation('GET_LICENSES_ORDER'),
    IS_LICENSE_KEY_VALID: createAsyncMutation('IS_LICENSE_KEY_VALID'),
    GET_CODE_TYPE: createAsyncMutation('GET_CODE_TYPE'),
}

const license = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getLicenseKeysCustomer(store, customerId) {
            let url = api.licenseKey + 'Customer/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSE_KEYS_CUSTOMER })
        },
        getLicenseKeysOrder(store, orderId) {
            let url = api.licenseKey + 'Order/' + orderId
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSE_KEYS_ORDER })
        },
        validateLicenseKey(store, licenseKey) {
            let url = api.licenseKey + licenseKey
            return doAsyncGet(store, { url, mutationTypes: types.IS_LICENSE_KEY_VALID })
        },
        getLicensesCustomer(store, customerId) {
            let url = api.license + 'Customer/' + customerId
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSES_CUSTOMER })
        },

        getLicensesOrder(store, orderId) {
            let url = api.license + 'Order/' + orderId
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSES_ORDER })
        },

        getLicense(store, id) {
            let url = api.license + id
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSE })
        },

        getCodeType(store, code) {
            let url = api.licenseKey + 'GetCodeType/' + code
            return doAsyncGet(store, {url, mutationTypes: types.GET_CODE_TYPE })
        },

        getLicensesForRenewUpgrade(store, payload) {
            let url = api.license + 'Customer/'
            if (payload) {
                url += payload.customerId + '/CanRenewUpgrade'
                url += '?productId=' + payload.productId
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_LICENSES_FOR_RENEW_UPGRADE })
        },
        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default license
